import { Component } from '@angular/core';
import { GenderService } from '../gender.service';
import { Gender } from '../gender';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-gender-edit',
  templateUrl: 'edit.component.html',
})
export class GenderEditComponent {
  /**
   * Details of the gender being edited.
   */
  public gender: Gender;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {GenderService} genderService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private genderService: GenderService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.genderService.loading.subscribe(result => (this.isLoading = result));
    this.route.params.subscribe(params => this.loadGender(params.id));
  }

  /**
   * Perform the edit action which send the edited gender to the backend.
   */
  public edit() {
    const editGender = this.genderService
      .updateGender(this.gender.id, this.gender)
      .subscribe(
        (result: Gender) => {
          this.notificationService.success(
            `Gender Updated`,
            `The gender ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.gender = new Gender();
          editGender.unsubscribe();
          this.router.navigate(['/genders']);
        },
        err => {
          this.notificationService.error(
            `Gender Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/genders']);
        },
      );
  }

  /**
   * Loads the requested gender so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadGender(id: string) {
    this.genderService.findGender(id).subscribe(
      result => {
        this.gender = result;
      },
      err => {
        this.notificationService.error(
          `Gender Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/genders']);
      },
    );
  }
}
